import { render } from "./InternalCaseNotes.vue?vue&type=template&id=79449941"
import script from "./InternalCaseNotes.vue?vue&type=script&lang=js"
export * from "./InternalCaseNotes.vue?vue&type=script&lang=js"

import "./InternalCaseNotes.vue?vue&type=style&index=0&id=79449941&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pendingCases/InternalCaseNotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79449941"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79449941', __exports__)) {
    console.log('reload')
    api.reload('79449941', __exports__)
  }
  
  module.hot.accept("./InternalCaseNotes.vue?vue&type=template&id=79449941", () => {
    console.log('re-render')
    api.rerender('79449941', render)
  })

}


export default __exports__